import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from ".";

/**
 * Check if an email is approved in the beta_list collection.
 * Returns true if the email has an entry with allowed === true.
 */
export const isBetaApproved = async (email: string): Promise<boolean> => {
  const q = query(
    collection(db, "beta_list"),
    where("email", "==", email),
    where("allowed", "==", true)
  );
  const snap = await getDocs(q);
  return !snap.empty;
};
